/**
 * Shared severity heuristics for risk/issue surfaces (RiskIssueList, the home
 * DeliverablesPanel's high-severity strip). Matches free-text impact /
 * probability / priority values; item 18's impact-select canonicalization is
 * expected to align its option strings with these patterns — change both
 * together or the option values silently stop ranking.
 */ export const isHigh = (s)=>/high|critical/i.test(s);
export const isMed = (s)=>/med|moderate/i.test(s);
export const isClosed = (s)=>/closed|resolved|mitigated|done|converted/i.test(s);
export function sev(...signals) {
    if (signals.some(isHigh)) return 'high';
    if (signals.some(isMed)) return 'med';
    return 'low';
}
export const sevRank = {
    high: 0,
    med: 1,
    low: 2
};
